function addToCart(variant_id, qty) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        setTimeout(function() {
          window.location.href = '/cart'; 
        }, 300);
      }
    });
  }

function addToUpsell(variant_id, redirect) {
    data = {
      "id": variant_id,
      "quantity": 1,
      "properties": {
        "Type": "Upsell"
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        if(redirect == 'extra-popup'){
          window.scrollTo({ top: 80, behavior: 'smooth' });
          $('#wrap-popup-upsell-1').removeClass('is-visible');
          $('#wrap-popup-upsell-2').addClass('is-visible');
        }else{
          setTimeout(function() {
            window.location.href = redirect; 
          }, 300);
        }
      }
    });
  }

function addToCartWithGift(variant_id, qty) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        setTimeout(function() {
          //window.location.href = '/cart'; 
          addToCart(42910147870888,1);
        }, 300);
      }
    });
  }

$(".site-nav--has-dropdown").hover(function() {
  var isHovered = $(this).is(":hover");
  if (isHovered) {
    $(this)(".site-nav__dropdown").stop().slideDown(300);
  } else {
    $(this)(".site-nav__dropdown").stop().slideUp(300);
  }
});


if (document.cookie.indexOf('OptanonAlertBoxClosed') == -1 ) {
   console.log('has cookies ......OptanonAlertBoxClosed');
  var myVar = setInterval(myTimer, 500);
  function myTimer() {
    if( $('#onetrust-banner-sdk').length ) {
      $('body, html').scrollTop(0);
      clearInterval(myVar);
    }
  }
  
} else {
   console.log('No------ cookies.....OptanonAlertBoxClosed');
}




